import React, { useContext, useEffect, useState } from "react";
// import { getStudyDrilldownData } from "../../service/AnalyticsService";
import { DetailsList, DetailsListLayoutMode, SelectionMode } from "@fluentui/react";
import themeContext from "../../context/theme/ThemeContext";
import { getFormatedDate } from "../IssuesAndTroubleshooting/helper/helper";
// const StudyDrilldownTable = ({ selectedDate }) => {
// const StudyDrilldownTable = ({ selectedDate, chartConfigDto, hospitalIdsMappedToCurrentUser, userIds }) => {
  // const [items, setItems] = useState([]);
  const StudyDrilldownTable = ({ selectedDate, data = [] }) => {
  const [items, setItems] = useState(data);
  const {themeName} = useContext(themeContext);
  useEffect(() => {
    setItems(data); // keep local state in sync when props change
  }, [data]);


/** Full date */
 const displayDate = (date) =>
  getFormatedDate(date, "DD-MM-YYYY");

/** Only time */
 const displayTime = (date) =>
  getFormatedDate(date, "HH:mm:ss");

/** Date + Time */
 const displayDateTime = (date) =>
  getFormatedDate(date, "DD-MM-YYYY HH:mm:ss");

/** DICOM HHMMSS -> user timezone */
 const displayDicomTime = (studyDate, dicomTime) => {
  if (!studyDate || !dicomTime || dicomTime.length < 6) return "-";

  // Combine DICOM date + time into backend datetime
  const formatted =
    studyDate + " " +
    dicomTime.substring(0,2) + ":" +
    dicomTime.substring(2,4) + ":" +
    dicomTime.substring(4,6);

  return getFormatedDate(formatted, "HH:mm:ss");
};

const formatSecondsToHHMMSS = (totalSeconds) => {
  if (totalSeconds == null || isNaN(totalSeconds)) return '-';

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return [
    String(hours).padStart(2, '0'),
    String(minutes).padStart(2, '0'),
    String(seconds).padStart(2, '0'),
  ].join(':');
};

//   useEffect(() => {
//     async function fetchData() {
//       // const res = await getStudyDrilldownData(selectedDate);
//     const res = await getStudyDrilldownData(selectedDate, chartConfigDto, hospitalIdsMappedToCurrentUser, userIds);

//       if (res.status === 200) {
//         setItems(res.data.data || []);
//       }
//     }
//     fetchData();
//   // }, [selectedDate]);
// }, [selectedDate, chartConfigDto, hospitalIdsMappedToCurrentUser, userIds]);

//   const columns = [
//     { key: 'studyId', name: 'Study Id', fieldName: 'studyId', minWidth: 60 },
//     { key: 'modality', name: 'Modality', fieldName: 'modality', minWidth: 60 },
//     { key: 'studyDescription', name: 'Study Description', fieldName: 'studyDescription', minWidth: 100 },
//     { key: 'aiModel', name: 'AI Model', fieldName: 'aiModel', minWidth: 100 },
//     { key: 'clientName', name: 'Client', fieldName: 'clientName', minWidth: 100 },
//     { key: 'radiologistName', name: 'Radiologist', fieldName: 'radiologistName', minWidth: 100 },
//     { key: 'aiProcessed', name: 'AI Y/N', fieldName: 'aiProcessed', minWidth: 60 },
//     { key: 'studyTime', name: 'Study Time', fieldName: 'studyTime', minWidth: 110 },
//     { key: 'studyUploadTime', name: 'Upload Time', fieldName: 'studyUploadTime', minWidth: 110 },
//     { key: 'studyAssignTime', name: 'Assign Time', fieldName: 'studyAssignTime', minWidth: 110 },
//     { key: 'studyOpenTime', name: 'Open Time', fieldName: 'studyOpenTime', minWidth: 110 },
//     { key: 'reportSubmitTime', name: 'Submit Time', fieldName: 'reportSubmitTime', minWidth: 110 },
//     { key: 'tatUploadToSubmit', name: 'Upload→Submit TAT (s)', fieldName: 'tatUploadToSubmit', minWidth: 90 },
//     { key: 'tatAssignToSubmit', name: 'Assign→Submit TAT (s)', fieldName: 'tatAssignToSubmit', minWidth: 90 },
//     { key: 'tatOpenToSubmit', name: 'Open→Submit TAT (s)', fieldName: 'tatOpenToSubmit', minWidth: 90 },
//   ];

//   return (
//     <div style={{ padding: "10px" , marginTop: "20px",marginLeft:"calc(100% - 55%)"}}>
//       <h3>Drilldown Studies for {selectedDate}</h3>
//         <div style={{ overflowX: "auto", width: "100%",backgroundColor: "rgba(97, 117, 144, 0.28)" }}>
//             <div style={{ width: "max-content" }}>
//             <DetailsList
//                 items={items}
//                 columns={columns}
//                 layoutMode={DetailsListLayoutMode.fixedColumns}
//                 selectionMode={SelectionMode.none}
//                 //styles={{ root: { overflowX: "auto" } }}
//             />
//             </div>
//         </div>
//     </div>
//   );
  return (
    <div style={{ height: "50vh" , minWidth: "100%", marginBottom: "10px"}}>
      {/* <h3 style ={{marginTop:"25px"}}>Reported Date {formatDateToDDMMYYYY(selectedDate)}</h3> */}
       <div className="custom-drilldown-studylist-modal-scroll" style={{
        maxHeight: "62vh", // or any value that fits your layout
        overflowY: "auto",
        width: "100%",
        overflowX: "auto",
        border: "1px solid #334155", // optional
        borderRadius: "4px",
        marginBottom: "10px",
        background: themeName === "light" ? "#EEEEEE":"var(--studylist-search-and-tab-section-background)",
    }}>
      <table style={{ borderCollapse: "collapse", width: "100%", backgroundColor: "var(--background-theme-color)", color: "var(--studylist-table-thead-text-color)" }}>
        <thead>
          <tr>
            <th className="table-cell-head" style={{ minWidth: "120px" }}>Patient Details</th>
            <th className="table-cell-head" style={{ minWidth: "100px" }}>Study Details</th>
            <th className="table-cell-head" style={{ minWidth: "60px" }}>AI Model</th>
            <th className="table-cell-head" style={{ minWidth: "130px" }}>Radiologist <br />/ Client</th>
            {/* <th className="table-cell-head" style={{ minWidth: "90px" }}>Upload <br />/ Assign Time</th>
            <th className="table-cell-head" style={{ minWidth: "90px" }}>Open <br />/ Submit Time</th> */}
            <th className="table-cell-head" style={{ minWidth: "70px" }}>Upload <br />Date</th>
            <th className="table-cell-head" style={{ minWidth: "70px" }}>Assign <br />Date</th>
            <th className="table-cell-head" style={{ minWidth: "70px" }}>Open <br />Date</th>
            <th className="table-cell-head" style={{ minWidth: "70px" }}>Submit <br />Date</th>
            {/* <th className="table-cell-head" style={{ minWidth: "90px" }}>
              TAT <br />
              <small>(HH:mm:ss)</small>
            </th> */}
            <th className="table-cell-head" style={{ minWidth: "90px" }}>Scan To <br />Submit TAT<br /><small>(HH:mm:ss)</small></th>
            <th className="table-cell-head" style={{ minWidth: "90px" }}>Upload To <br />Submit TAT<br /><small>(HH:mm:ss)</small></th>
            <th className="table-cell-head" style={{ minWidth: "90px" }}>Assign To <br />Submit TAT<br /><small>(HH:mm:ss)</small></th>
            <th className="table-cell-head" style={{ minWidth: "90px" }}>Open To <br />Submit TAT<br /><small>(HH:mm:ss)</small></th>

          </tr>
        </thead>
        <tbody>
          {items.length === 0 ? (
            <tr>
              <td colSpan={12} style={{ textAlign: "center", padding: "20px", color: "#94a3b8" }}>
                No Study Found (Please clear any applied filters)
              </td>
            </tr>
          ) : (
          items.map((item, idx) => (
            <tr key={idx} style={{ borderTop: "1px solid #334155" }}>
              {/* <td>{item.studyId}</td> */}
              <td className="table-cell">
                {/* {item.patientName || '-'}<br />
                {item.patientId || '-'}<br />
                {item.gender || '-'} | {item.age || '-'} */}
                <span className="ellipsis-cell" title={`Patient Name: ${item.patientName}`}>{item.patientName}</span><br />
                <span className="ellipsis-cell" title={`Patient ID: ${item.patientId}`}>{item.patientId}</span><br />
                {/* <span className="ellipsis-cell" title={`Gender | Age: ${item.gender} | ${item.age}`}>{item.gender} | {item.age}</span> */}
                <span className="ellipsis-cell" title={`Gender: ${item.gender}`}>{item.gender}</span>&nbsp;&nbsp;|&nbsp;&nbsp;
                <span className="ellipsis-cell" title={`Age: ${item.age}`}> {item.age}</span>
              </td>
              <td className="table-cell">
               {/* {item.modality} | {item.studyDescription} */}
                {/* <br /> */}
                {/* {item.studyTime} */}
                {/* {formatTime(item.studyTime)} */}
                {/* <span className="ellipsis-cell" title={`Modality | Description: ${item.modality} | ${item.studyDescription}`}>{item.modality} | {item.studyDescription}</span><br /> */}
                <span className="ellipsis-cell" title={`Modality: ${item.modality}`}>{item.modality}</span>&nbsp;&nbsp;|&nbsp;&nbsp;
                <span className="ellipsis-cell" title={`Description: ${item.studyDescription}`}> {item.studyDescription}</span><br />
                <span className="ellipsis-cell"
      title={`Study Date: ${getFormatedDate(item.studyDateTime, "DD-MM-YYYY")}`}>
  {getFormatedDate(item.studyDateTime, "DD-MM-YYYY")}
</span>
<br />
<span className="ellipsis-cell"
      title={`Study Time: ${getFormatedDate(item.studyDateTime, "HH:mm:ss")}`}>
  {getFormatedDate(item.studyDateTime, "HH:mm:ss")}
</span>
              </td>
              <td className="table-cell">
                {/* {item.aiModel || "-"} */}
                {/* <br /> */}
                <span className="ellipsis-cell" title={`AI Model: ${item.aiModel}`}>{item.aiModel || "-"}</span><br />
                <span className="ellipsis-cell" title={`AI Processed(Yes/No): ${item.aiProcessed === "Y" ? "Yes" : "No"}`}>{item.aiProcessed === "Y" ? "Yes" : "No"}</span>
                {/* {item.aiProcessed === "Y" ? "Yes" : "No"} */}
              </td>
              {/* <td className="table-cell"> */}
                {/* {item.radiologistName} */}
                {/* <br /> */}
                {/* {item.clientName} */}
                {/* <span className="ellipsis-cell" title={`Radiologist: ${item.radiologistName}`}>{item.radiologistName}</span><br />
                <span className="ellipsis-cell" title={`Client: ${item.clientName}`}>{item.clientName}</span>
              </td> */}
              <td className="table-cell">
                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                  {/* Radiologist */}
                  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <div className="initial-circle" title="Radiologist">R</div>
                    <span className="ellipsis-cell" title={`Radiologist: ${item.radiologistName}`}>
                      {item.radiologistName}
                    </span>
                  </div>

                  {/* Client */}
                  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <div className="initial-circle" title="Client">C</div>
                    <span className="ellipsis-cell" title={`Client: ${item.clientName}`}>
                      {item.clientName}
                    </span>
                  </div>
                </div>
              </td>

              {/* <td className="table-cell">
                <span className="ellipsis-cell" title={`Upload Time: ${formatTime(item.studyUploadTime)}`}>{formatTime(item.studyUploadTime)}</span><br />
                <span className="ellipsis-cell" title={`Assign Time: ${formatTime(item.studyAssignTime)}`}>{formatTime(item.studyAssignTime)}</span>
              </td>
              <td className="table-cell">
                <span className="ellipsis-cell" title={`Open Time: ${formatTime(item.studyOpenTime)}`}>{formatTime(item.studyOpenTime)}</span><br />
                <span className="ellipsis-cell" title={`Submit Time: ${formatTime(item.reportSubmitTime)}`}>{formatTime(item.reportSubmitTime)}</span>
              </td> */}
              <td className="table-cell">
                <div>
                  <div className="ellipsis-cell" title="Upload Date">
  {displayDate(item.studyUploadTime)}
</div>
<div className="ellipsis-cell" title="Upload Time">
  {displayTime(item.studyUploadTime)}
</div>

                </div>
              </td>
              <td className="table-cell">
                <div>
                  <div className="ellipsis-cell" title="Assign Date">
  {displayDate(item.studyAssignTime)}
</div>
<div className="ellipsis-cell" title="Assign Time">
  {displayTime(item.studyAssignTime)}
</div>

                </div>
              </td>
              <td className="table-cell">
  <div>
    <div
      className="ellipsis-cell"
      title={`Open Date: ${getFormatedDate(item.studyOpenTime, "DD-MM-YYYY")}`}
    >
      {getFormatedDate(item.studyOpenTime, "DD-MM-YYYY")}
    </div>

    <div
      className="ellipsis-cell"
      title={`Open Time: ${getFormatedDate(item.studyOpenTime, "HH:mm:ss")}`}
    >
      {getFormatedDate(item.studyOpenTime, "HH:mm:ss")}
    </div>
  </div>
</td>

<td className="table-cell">
  <div>
    <div
      className="ellipsis-cell"
      title={`Submit Date: ${getFormatedDate(item.reportSubmitTime, "DD-MM-YYYY")}`}
    >
      {getFormatedDate(item.reportSubmitTime, "DD-MM-YYYY")}
    </div>

    <div
      className="ellipsis-cell"
      title={`Submit Time: ${getFormatedDate(item.reportSubmitTime, "HH:mm:ss")}`}
    >
      {getFormatedDate(item.reportSubmitTime, "HH:mm:ss")}
    </div>
  </div>
</td>


              {/* <td className="table-cell">
                <table style={{ width: "100%", fontSize: "12px" }}>
                    <tbody>
                    <tr>
                        <td style={{ padding: "2px" }} title="Study Scan to Reporting Time">{formatSecondsToHHMMSS(item.tatScanToSubmit)}</td>
                        <td style={{ padding: "2px" }} title="Study Upload to Reporting Time">{formatSecondsToHHMMSS(item.tatUploadToSubmit)}</td>
                    </tr>
                    <tr>
                        <td style={{ padding: "2px" }} title="Study Assignment to Reporting Time">{formatSecondsToHHMMSS(item.tatAssignToSubmit)}</td>
                        <td style={{ padding: "2px" }} title="Study Open to Reporting Time">{formatSecondsToHHMMSS(item.tatOpenToSubmit)}</td>
                    </tr>
                    </tbody>
                </table>
              </td> */}
              <td className="table-cell">
                <span style={{ padding: "4px" }} className="ellipsis-cell" title="Scan To Reporting TAT">{formatSecondsToHHMMSS(item.tatScanToSubmit)}
                </span>
              </td>
              <td className="table-cell">
                <span style={{ padding: "4px" }} className="ellipsis-cell" title="Upload To Submit TAT">{formatSecondsToHHMMSS(item.tatUploadToSubmit)}
                </span>
              </td>
              <td className="table-cell">
                <span style={{ padding: "4px" }} className="ellipsis-cell" title="Assignment To Reporting TAT">{formatSecondsToHHMMSS(item.tatAssignToSubmit)}
                </span>
              </td>
              <td className="table-cell">
                <span style={{ padding: "4px" }} className="ellipsis-cell" title="Open To Reporting TAT">{formatSecondsToHHMMSS(item.tatOpenToSubmit)}
                </span>
              </td>
            </tr>
          ))
        )}
        </tbody>
      </table>
    </div>
    </div>

  );
};

export default StudyDrilldownTable;
